var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVerticalMenuDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_460_2271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_460_2271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99943 11.6644C6.6786 11.6644 6.40404 11.5503 6.17576 11.322C5.9471 11.0933 5.83276 10.8186 5.83276 10.4977C5.83276 10.1769 5.9471 9.90214 6.17576 9.67347C6.40404 9.44519 6.6786 9.33106 6.99943 9.33106C7.32026 9.33106 7.59501 9.44519 7.82368 9.67347C8.05196 9.90214 8.1661 10.1769 8.1661 10.4977C8.1661 10.8186 8.05196 11.0933 7.82368 11.322C7.59501 11.5503 7.32026 11.6644 6.99943 11.6644ZM6.99943 8.16439C6.6786 8.16439 6.40404 8.05006 6.17576 7.82139C5.9471 7.59311 5.83276 7.31855 5.83276 6.99772C5.83276 6.67689 5.9471 6.40214 6.17576 6.17347C6.40404 5.94519 6.6786 5.83105 6.99943 5.83105C7.32026 5.83105 7.59501 5.94519 7.82368 6.17347C8.05196 6.40214 8.1661 6.67689 8.1661 6.99772C8.1661 7.31855 8.05196 7.59311 7.82368 7.82139C7.59501 8.05006 7.32026 8.16439 6.99943 8.16439ZM6.99943 4.66439C6.6786 4.66439 6.40404 4.55006 6.17576 4.32139C5.9471 4.09311 5.83276 3.81855 5.83276 3.49772C5.83276 3.17689 5.9471 2.90233 6.17576 2.67405C6.40404 2.44539 6.6786 2.33105 6.99943 2.33105C7.32026 2.33105 7.59501 2.44539 7.82368 2.67405C8.05196 2.90233 8.1661 3.17689 8.1661 3.49772C8.1661 3.81855 8.05196 4.09311 7.82368 4.32139C7.59501 4.55006 7.32026 4.66439 6.99943 4.66439Z",
    fill: "white",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVerticalMenuDark);
export default __webpack_public_path__ + "static/media/ic-vertical-menu-dark.3e1176e439d0a195386799980f1579f3.svg";
export { ForwardRef as ReactComponent };